import React, { memo } from 'react';
import { Slide, Step, StepLabel } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { useTranslation } from 'react-i18next';
import { SlideDirection, Step as StepInterface } from '../types';
import { StepConnector, StyledStepper } from './style';
import StepIcon from './StepIcon';

interface StepperProps {
    steps: StepInterface[];
    activeStep: number;
    slideDirection?: SlideDirection;
}

const Stepper = ({ steps, activeStep, slideDirection }: StepperProps ) => {
    const { t } = useTranslation();
    return (
        <>
            <StyledStepper activeStep={activeStep} alternativeLabel connector={<StepConnector />}>
                {steps.map(({ title }, index) => (
                    <Step key={uuid()}>
                        <StepLabel
                            StepIconComponent={originalProps => (
                                <StepIcon
                                    label={index === activeStep ? t(...title) : null}
                                    index={index}
                                    stepsCount={steps.length - 1}
                                    {...originalProps}
                                />
                            )}
                        />
                    </Step>
                ))}
            </StyledStepper>
            {steps.map(({ component }, index) => (
                <Slide key={uuid()} unmountOnExit in={index === activeStep} direction={slideDirection}>
                    {component}
                </Slide>
            ))}
        </>
    );
};

export default memo(Stepper);